var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{staticClass:"vx-col w-full mt-4"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Instituciones"}},[_c('Instituciones')],1),(_vm.permisoRoot)?_c('vs-tab',{attrs:{"label":"Periodos"}},[_c('Periodos')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }